module.exports = __webpack_public_path__ + "img/wx.c605bfeb.png";